(function () {
  function resizeFrame(frame) {
    try {
      var doc = frame.contentDocument || (frame.contentWindow && frame.contentWindow.document);
      if (!doc) return;
      var height = Math.max(
        doc.body ? doc.body.scrollHeight : 0,
        doc.documentElement ? doc.documentElement.scrollHeight : 0,
        window.innerHeight || 800
      );
      if (height > 0) frame.style.height = height + 'px';
    } catch (e) {
      frame.style.height = '100vh';
    }
  }

  function renderRenaissanceCarePage() {
    var frameId = window.RENAISSANCE_CARE_FRAME_ID;
    var frame = frameId ? document.getElementById(frameId) : document.querySelector('.renaissance-care-page-frame');
    var chunks = window.RENAISSANCE_CARE_HTML_CHUNKS || [];

    if (!frame) return;
    if (!chunks.length) {
      frame.outerHTML = '<div style="padding:40px;text-align:center;color:#b00020;">Renaissance Care chunks not loaded. Please upload all chunk files in Assets.</div>';
      return;
    }

    var html = chunks.join('');
    frame.srcdoc = html;

    frame.addEventListener('load', function () {
      resizeFrame(frame);
      setTimeout(function(){ resizeFrame(frame); }, 500);
      setTimeout(function(){ resizeFrame(frame); }, 1500);
      setTimeout(function(){ resizeFrame(frame); }, 3000);
    });
  }   

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderRenaissanceCarePage);
  } else {
    renderRenaissanceCarePage();
  }
})();
   